import Integration from '@/pages/integration/Integration'

export default [
    {
      path: '/',
      name: 'External Integration',
      component: Integration
    }
]